import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import Select from 'react-select';
import { actionCreators } from '../../data/Suppliers/actions';
import RenderSelectedSuppliers from './components/renderSelectedSuppliers';

const Suppliers = () => {
  const dispatch = useDispatch();
  const { setValue } = useFormContext();

  const { values, isFetching, hasError, selectedSuppliers, hasFiles } = useSelector(
    (state) => state.Admin.data.suppliers
  );

  const handleFocus = () => {
    if (!hasFiles) {
      dispatch(actionCreators.getSuppliers());
    }
  };

  const handleChange = (selected) => {
    dispatch(actionCreators.selectSupplier(selected || []));
    setValue('selectedSuppliers', selected || [], { shouldValidate: true, shouldDirty: true });
  };

  useEffect(() => {
    setValue('selectedSuppliers', selectedSuppliers || [], { shouldValidate: false, shouldDirty: false });
  }, [selectedSuppliers, setValue]);

  return (
    <>
      <Select
        options={values}
        onFocus={handleFocus}
        onBlurResetsInput={false}
        onCloseResetsInput={false}
        isLoading={isFetching}
        placeholder="Klicka och välj involverade adresskällor"
        loadingMessage={() => 'Laddar adresskällor...'}
        value={selectedSuppliers}
        onChange={handleChange}
        isMulti
        isDisabled={hasError}
      />
      {hasError && <div>Fel uppstod vid hämtning av leverantörer</div>}
      <RenderSelectedSuppliers options={selectedSuppliers || []} />
    </>
  );
};

export default Suppliers;
export { Suppliers };
